// @generated by protoc-gen-es v2.10.2 with parameter "target=js+dts,import_extension=none"
// @generated from file auth/v1/auth.proto (package auth.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file auth/v1/auth.proto.
 */
export const file_auth_v1_auth = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message auth.v1.InitiateOAuthRequest.
 * Use `create(InitiateOAuthRequestSchema)` to create a new message.
 */
export const InitiateOAuthRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 0);

/**
 * Describes the message auth.v1.InitiateOAuthResponse.
 * Use `create(InitiateOAuthResponseSchema)` to create a new message.
 */
export const InitiateOAuthResponseSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 1);

/**
 * Describes the message auth.v1.HandleOAuthCallbackRequest.
 * Use `create(HandleOAuthCallbackRequestSchema)` to create a new message.
 */
export const HandleOAuthCallbackRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 2);

/**
 * Describes the message auth.v1.HandleOAuthCallbackResponse.
 * Use `create(HandleOAuthCallbackResponseSchema)` to create a new message.
 */
export const HandleOAuthCallbackResponseSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 3);

/**
 * Describes the message auth.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 4);

/**
 * Describes the message auth.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 5);

/**
 * Describes the message auth.v1.RevokeTokenRequest.
 * Use `create(RevokeTokenRequestSchema)` to create a new message.
 */
export const RevokeTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 6);

/**
 * Describes the message auth.v1.RevokeTokenResponse.
 * Use `create(RevokeTokenResponseSchema)` to create a new message.
 */
export const RevokeTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 7);

/**
 * Describes the message auth.v1.GetUserInfoRequest.
 * Use `create(GetUserInfoRequestSchema)` to create a new message.
 */
export const GetUserInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 8);

/**
 * Describes the message auth.v1.GetUserInfoResponse.
 * Use `create(GetUserInfoResponseSchema)` to create a new message.
 */
export const GetUserInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 9);

/**
 * Describes the message auth.v1.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema = /*@__PURE__*/
  messageDesc(file_auth_v1_auth, 10);

/**
 * Describes the enum auth.v1.UserStatus.
 */
export const UserStatusSchema = /*@__PURE__*/
  enumDesc(file_auth_v1_auth, 0);

/**
 * UserStatus indicates the state of a user account.
 *
 * @generated from enum auth.v1.UserStatus
 */
export const UserStatus = /*@__PURE__*/
  tsEnum(UserStatusSchema);

/**
 * AuthService handles OAuth authentication flows.
 *
 * @generated from service auth.v1.AuthService
 */
export const AuthService = /*@__PURE__*/
  serviceDesc(file_auth_v1_auth, 0);

